import { format } from '../../lib/helpers/CurrencyConversionHelper';
import { P2GText } from '@parcel2go/core-ui';

type CurrencyConversion = {
  ImportedCode: string;
  ImportedValue: number;
  ConvertedCode: string;
  ConvertedValue: number;
  Rate: number;
};
type CurrencyConversionProps = {
  ValueJSON: string;
};

export const CurrencyConversion: React.FC<CurrencyConversionProps> = (props) => {
  const conversion: CurrencyConversion = JSON.parse(props.ValueJSON);
  const renderable =
    conversion &&
    conversion.ConvertedCode &&
    conversion.ConvertedValue &&
    conversion.ImportedCode &&
    conversion.ImportedValue &&
    conversion.Rate;

  if (!renderable) {
    return null;
  }

  const importVal = format(conversion.ImportedValue, conversion.ImportedCode);

  const from = format(1, conversion.ImportedCode);
  const to = format(conversion.Rate, conversion.ConvertedCode);

  return (
    renderable && (
      <P2GText variant="body2" component="span" colour="textSecondary" small>
        Imported as {importVal}. Rate {from} = {to}.
      </P2GText>
    )
  );
};
